export function Cart() {
	this.cartedProducts = [],
    this.coupon = null,
	this.shippingId = null,
	this.paymentId = null,
	this.remarks = null,
	this.storeId = null
}